<div class="mt-5 mb-16 w-full px-6 py-4 md:px-16">
  <div class="flex flex-col gap-6">
    <div class="flex flex-col gap-8">
      <div class="border-b border-border-secondary pb-6">
        <h1
          class="mt-5 mb-2 bg-linear-to-b from-gradient-start from-0% via-gradient-middle2 via-50% to-gradient-end to-100% bg-clip-text text-5xl leading-tight text-transparent lg:text-8xl"
        >
          {{ 'pages.articlePurchase.title' | translate }}
        </h1>
        <p class="max-w-3xl text-secondary-text">
          {{ 'pages.articlePurchase.description' | translate }}
        </p>
      </div>

      @if (currentStep(); as currentStep) {
        <dhp-article-purchase-flow-context
          [currentStep]="currentStep"
          [includeStudentEmailStep]="includeStudentEmailStep()"
          [includeVerificationStep]="includeVerificationStep()"
        ></dhp-article-purchase-flow-context>
      }
    </div>

    <router-outlet class="hidden"></router-outlet>
  </div>
</div>
